(function(angular) {
    'use strict';

    angular.module('whatsApp')

    /**
     *
     */
    .factory('whatsAppSharedService',
        ['$http', '$q', 'portalConfig',
            function ($http, $q, portalConfig) {
        
        var hsms = {};

        var fac = {
            getHsms: getHsms,
            getHsm: getHsm,
            saveHsms: saveHsms,
            hsmPreview: hsmPreview
        };
        //apispacelevel
        return fac;

        function getHsms(apiSpaceId){
            return hsms[apiSpaceId];
        }

        function getHsm(apiSpaceId, templateName){
            var hsm;
            if(hsms[apiSpaceId]){
                hsm = hsms[apiSpaceId].find(function(singleHsm){
                    return singleHsm.templateName === templateName;
                })
            }
            return hsm;
        }

        function saveHsms(apiSpaceId, hsmsData){
            return hsms[apiSpaceId] = hsmsData;
        }

        function hsmPreview(message, params) {
            if(!message){
                return "";
            }
            return message.replace(/{{\d+}}/g, function(match){
                var index = parseInt(match.slice(0,-2).substring(2)) - 1;
                if(params[index]){
                    if(typeof params[index] === "object"){
                        return params[index].default;
                    } else {
                        return params[index]
                    }
                }
                return match;
            });
        }

    }]);

})(window.angular);
